export default __webpack_public_path__ + "static/media/NetworkTimeFoundation.83318f4b.svg";